import React, { useEffect, useState } from "react";
import { Link, usePage } from '@inertiajs/react'



export default function Footer() {
    const { appName } = usePage().props

    return (
        <div className="w-full">
            <div className="container max-w-dasha mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-4 flex flex-wrap md:flex-nowrap items-end justify-between">
                <div className="space-y-3">
                    <div>
                        <Link href="/" className="font-medium">
                            {appName as string}
                        </Link>
                        <div>
                            Find the Best Price Before You Buy
                        </div>
                    </div>
                </div>

                <ul className="flex space-x-14">
                    <li>
                        <Link href="/about-us">About Us</Link>
                    </li>
                    <li>
                        <Link href="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                        <Link href="/contact">Contact Us</Link>
                    </li>
                </ul>
                {/* <div className="font-medium">
                    <a href="mailto:anokhinadaria0212@gmail.com">anokhinadaria0212@gmail.com</a>
                </div> */}
            </div>
        </div>
    )
}